export default __webpack_public_path__ + "static/media/login_bg_shape.780b0d21.png";